import StockAdd from "./StockAdd";

export {StockAdd}
export default StockAdd
